/**
 * Whether any value differs, by identity, from the one at the same position last time; true when
 * there was no last time.
 */
export const haveChanged = (previous: readonly unknown[] | undefined, next: readonly unknown[]) =>
  !previous || next.some((value, index) => value !== previous[index])
